import React from "react";
import "./UploadingIcon.scss";

interface UploadingIconProps {
  className?: string;
  width?: number;
  height?: number;
}

const UploadingIcon: React.FC<UploadingIconProps> = ({
  className = "",
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`uploading-icon ${className}`}
    >
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
        fill="#FFF4FC"
      />
      <g clipPath="url(#clip0_8025_14718)" className="spinner">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.3335 6.00065C11.3335 5.63246 11.6319 5.33398 12.0001 5.33398C15.682 5.33398 18.6668 8.31875 18.6668 12.0007C18.6668 15.6825 15.682 18.6673 12.0001 18.6673C9.68807 18.6673 7.6513 17.4898 6.45648 15.7048C6.25167 15.3989 6.33368 14.9848 6.63965 14.78C6.94562 14.5752 7.35968 14.6572 7.56449 14.9631C8.52237 16.3941 10.1516 17.334 12.0001 17.334C14.9456 17.334 17.3335 14.9462 17.3335 12.0007C17.3335 9.05513 14.9456 6.66732 12.0001 6.66732C11.6319 6.66732 11.3335 6.36884 11.3335 6.00065Z"
          fill="#BE2BBB"
        />
      </g>
      <defs>
        <clipPath id="clip0_8025_14718">
          <rect width="16" height="16" fill="white" transform="translate(4 4)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UploadingIcon;
